<template>
    <div>
        <input type="hidden" :id="`contractor_ids_${service.service_id}_${ service.clone }`" v-model="user_id"/>
    </div>
</template>

<script>
export default {
    name: "ServiceContractor",
    props: {
        service: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>